import { DEVICEHQ } from '@/devicehq/api'

const createRebootCommand = (context, payload) => {
  // create reboot command
  console.log( 'createRebootCommand' )
  console.log( context, payload )
  DEVICEHQ.post(`/api/v2/devices/${payload.uuid}/commands/reboot`, {
    data: {},
  })
  .then(response => {
    context.commit('COMMAND_CREATED', response.data)
    //no need to reload device, but should reload command list for device 
  })
  .catch(error => {
    console.error(error)
  })
}
const getForDevice = (context, payload) => {
  // create reboot command
  console.log( 'getForDevice' )
  console.log( context, payload )
  DEVICEHQ.get(`/api/v2/devices/${payload.uuid}/commands`, {
    data: {},
  })
  .then(response => {
    context.commit('DEVICE_COMMANDS_UPDATED', response.data)
  })
  .catch(error => {
    console.error(error)
  })
}

export default {
  createRebootCommand,
  getForDevice
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/commands/actions.js